import Can from "../../utils/can";
import TermsTab from "../systemsettings/terms";

const TermsPage = () => {
  return (
    <div className="row">
      <Can permission={"view_page"}>
        <TermsTab />
      </Can>
    </div>
  );
};

export default TermsPage;
